package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.templates.selection.sections.FooterContact
import com.anjuros.website.templates.selection.sections.FooterLogo
import com.anjuros.website.templates.selection.sections.FooterMenu
import com.anjuros.website.templates.template8.components.Template8Header
import com.anjuros.website.templates.template8.components.Template8InfoCard
import com.anjuros.website.templates.template8.modules.Template8Info
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8ObserverViewportEntered
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun Template8InfoSection(
    width: CSSSizeValue<CSSUnit.percent> = 80.percent,
    clickable: Boolean = true
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 50.px, bottom = 100.px)
            .backgroundColor(Template8Theme.Gold2.rgb),
        contentAlignment = Alignment.TopCenter
    ) {

        Template8InfoContent(
            width = width,
            clickable = clickable
        )
    }
}

@Composable
fun Template8InfoContent(
    width: CSSSizeValue<CSSUnit.percent> = 80.percent,
    clickable: Boolean = true
){
    var animatedOpacity = remember { mutableStateListOf(0.0f) }

    repeat(Template8Info.entries.size-1){
        animatedOpacity.add(0.0f)
    }

    Template8Info.entries.forEach { info->
        Template8ObserverViewportEntered(
            sectionId = "info${info.ordinal}",
            distanceFromTop = 500.0
        ) {
            animatedOpacity[info.ordinal] = 1.0f
        }
    }


        SimpleGrid(
            numColumns = numColumns(base = 1, md = 1, lg = 3),
            modifier = Modifier.fillMaxWidth(width)
                .margin(top=50.px)
        ) {
        Template8Info.entries.forEach { infoCard ->
            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.Center
            ) {
                Template8InfoCard(
                    infoCard = infoCard,
                    animatedOpacity = animatedOpacity[infoCard.ordinal],
                    clickable = clickable
                )
            }
        }
    }
}

